import * as React from 'react';
import { connect } from 'react-redux';
import AppNavigation from "../presentation/AppNavigation"
import { updateHeaderByComponent } from '../redux-objects/actions';
import { UserInfo } from '../../Login/common/defaults';

interface INavControllerPropsFromState {
    currentUser: UserInfo
}

interface INavControllerPropsFromActions {
    updateHeaderByComponent:(headerInfo:string) => void;
}

type navType = INavControllerPropsFromActions & INavControllerPropsFromState;

class NavigationController extends React.Component<navType,any> {
    render() {
        const isAdmin = this.props.currentUser.userRoles.some((item) => (item.role.name == "Administrator" || item.role.name == "Local Admin"));
        return (
            <React.Fragment>
                <AppNavigation updateHeaderOnNav={this.props.updateHeaderByComponent} currentUser={this.props.currentUser} isAdmin={isAdmin} />
            </React.Fragment>
        )
    }
}

const mapStateToProps = (reduxState: any) => {
    return {
        currentUser: reduxState.Application.currentUser
    };
  };
  

const mapDispatchToProps = {
    updateHeaderByComponent
};
  
export default connect<INavControllerPropsFromState,INavControllerPropsFromActions>(mapStateToProps,mapDispatchToProps)(NavigationController);
